// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".zcc_product_name[data-v-271508be]{font-family:Exo\\ 2;font-size:24px}.collapse-toggles p[data-v-271508be]{cursor:pointer}.contract-status[data-v-271508be]{gap:20px}.contract-info[data-v-271508be]{gap:16px}.contract-data[data-v-271508be]{gap:30px}.contract-fields[data-v-271508be]{gap:16px}.plan-summary-cards[data-v-271508be]{width:100%;gap:16px}.report-icon[data-v-271508be]{font-size:20px}", ""]);
// Exports
module.exports = exports;
